import React, { useEffect, useState } from "react";

// Reuse the spinner style from background.js:
const Spinner = () => {
	return (
		<div
			className="
        inline-block
        h-4 w-4
        border-2 border-monadAccent border-solid
        rounded-full
        border-t-transparent
        animate-spin
      "
			role="status"
		>
			<span className="sr-only">Loading...</span>
		</div>
	);
};

// 1) All Asset URLs
const allAssetUrlsByCategory = {
	Monad: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - Black - Horizontal Logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - Default - Horizontal Logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - Inverted - Horizontal Logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - White - Horizontal Logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - Black - Stacked Logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - Default - Stacked Logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - Inverted - Stacked Logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - White - Stacked Logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - Black - Logo Mark.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - Default - Logo Mark.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/Monad Logo - White - Logo Mark.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/keone.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/tunez.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/kb.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/karmachog.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/john w rich kid 1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/john w rich kid 2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/john w rich kid 3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/john w rich kid 4.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/john w rich kid 5.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/fish_nad.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/molandak.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/chog no bg.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon1.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon2.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/pwdmonad.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon3.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon4.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon5.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon6.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon7.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon8.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon9.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon10.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon11.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon12.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon13.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon14.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon15.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon16.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon17.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon18.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon19.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon20.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon21.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/monad/mon22.webp",
	],
	SappySeals: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/sealicon.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/seals.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/seal1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/seal2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/3dcuteseal.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/seal4.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/seal1.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/seal2.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/3dglassesseal.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/3dmouseseal.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/seal3.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/frankenseal.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/wabog.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/diakou.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/stormr.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/beardedwab.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/flywheel.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/PIXL.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/stfuprimay.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/wab1.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/wab2.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/wab3.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/wab4.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/wab5.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Sappy/animated.png",
	],
	Omnia: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/omnialogo2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/omnia_logo.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/omnia.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/omnia_green.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/worldender.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/chompie1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/chompie2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/chompie3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/pet1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/pet2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/daik.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/pet3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/fire.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/water.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/earth.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/air.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/PIXL.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Omnia/pixl2.png",
	],
	Sealuminati: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_71.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/richard_sealuminati.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_4.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_5.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/Tunez_vr.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/Devil Horns.png",

		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/Molandak.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/Chog.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/G-Van.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/PIXL_Token.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/King_Loui_big.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/Stan_Tumbler_Thermos_big.png",
	],
	TheVans: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/vans1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/vans2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/vans3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/g-van.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/ethledger.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/smol.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/krito.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/ferfer.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/pasta.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/chuks.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/The Vans/5ive.png",
	],
	Meowwnads: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/cat.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/cat2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/cat3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/cat4.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/cat5.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/01.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/02.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/03.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/4.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/5.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/6.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/7.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/1111.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/333.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/2222.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Meowwnads/1111 (2).png",
	],
	SLMND: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_10.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_4.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_7.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_5.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_8.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_9.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_11.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SLMND/slmnd_12.png",
	],
	Chog: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/chog7.jpg",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/chog8.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/chog9.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/chog1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/chog2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/chog3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/chog4.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/chog5.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/bananna_suit.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Chog/RayJ.png",
	],
	Monadverse: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Monadverse/IMG_6611.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Monadverse/IMG_6612.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Monadverse/IMG_6615.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Monadverse/IMG_6620.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Monadverse/IMG_6622.png",
	],
	BlockNads: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/BlockNads/Sealuminati_Export_1.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/BlockNads/Sealuminati_Export_2.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/BlockNads/Sealuminati_Export_3.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/BlockNads/Sealuminati_Export_4.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/BlockNads/Sealuminati_Export_5.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/BlockNads/Sealuminati_Export_6.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/BlockNads/Sealuminati_Export_7.png",
	],
	Dusted: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Dusted/Logotype (Transparent).png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Dusted/Logomark (Transparent).png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Dusted/Mascot.png",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/Dusted/Mascot Alt.png",
	],
	SpikyNads: [
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/Spikynads_Logo_2.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/Spikynads_Logo_transparent_BG_4.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/Monad_Logo_Pixelated_1.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/chadpike_FB.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/erdinctpbg-1.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/firespike_FB.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/jakxtpbg.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/KGtpbg-2.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/m0neytpbg-3.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/mahertpbg-1.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/mondalftpbg-2.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/ssstpbg.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/tuntpbg-2.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/yottpbg-2.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/head4.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/head5.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/1000018773.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/1000018774.webp",
		"https://d39nah1etu3fy9.cloudfront.net/images/assets/SpikyNads/1000018775.webp",
	],
};

// 2) Preloader
function preloadImages(urls) {
	return Promise.allSettled(
		urls.map((url) => {
			return new Promise((resolve) => {
				const img = new Image();
				img.crossOrigin = "anonymous";
				img.onload = () => resolve({ url, img, status: "fulfilled" });
				img.onerror = () => resolve({ url, img: null, status: "rejected" });
				img.src = url;
			});
		})
	);
}

export default function Assets({
	canvasRef,
	layers,
	drawCanvas,
	updateAnySelected,
	isMobile,

	uploadedImage,
	category,
	setCategory,
	isAssetAdded,
	setIsAssetAdded,
	hasBackground,
	bgRect,
}) {
	// Local state
	const [loadingAssets, setLoadingAssets] = useState(false);
	const [assetsAreReady, setAssetsAreReady] = useState(false);
	const [maxHeightClass, setMaxHeightClass] = useState("");
	const [preloadedImages, setPreloadedImages] = useState({});
	const [lockAspectLocal, setLockAspectLocal] = useState(true);
	const selectedAsset = layers.current.find((l) => l.isSelected && l.type === "asset");

	useEffect(() => {
		if (selectedAsset) {
			setLockAspectLocal(!!selectedAsset.lockAspectRatio);
		}
	}, [selectedAsset]);

	// 3) "Load Assets" handler
	async function handleLoadAllAssets() {
		setLoadingAssets(true);
		const allUrls = Object.values(allAssetUrlsByCategory).flat();
		const results = await preloadImages(allUrls);

		const newMap = {};
		results.forEach((r) => {
			if (r.status === "fulfilled" && r.img) {
				newMap[r.url] = r.img; // store the actual Image() object
			}
		});
		setPreloadedImages(newMap);
		setAssetsAreReady(true);
		setLoadingAssets(false);
	}

	// Local function for uploading from disk
	function handleLocalAssetSelect(e) {
		if (!e.target.files?.length) return;
		const file = e.target.files[0];
		if (!file) return;

		const reader = new FileReader();
		reader.onload = (ev) => {
			const img = new Image();
			img.crossOrigin = "anonymous";
			img.onload = () => {
				const canvas = canvasRef.current;

				// 1) Full dimensions
				const originalWidth = img.width;
				const originalHeight = img.height;

				// 2) Initial displayed size (e.g. 150 px wide)
				const displayedWidth = Math.min(originalWidth, 150);
				const displayedHeight = (displayedWidth / originalWidth) * originalHeight;

				     // --- NEW: If we have a valid bgRect, ensure the asset fits entirely inside ---
				     if (bgRect?.current && bgRect.current.width > 0 && bgRect.current.height > 0) {
				       const r = bgRect.current;
				       // If even 150 is still bigger than the bg, scale down further
				       const scaleFactor = Math.min(
				         r.width / displayedWidth,
				         r.height / displayedHeight
				       );
				       if (scaleFactor < 1) {
				         displayedWidth *= scaleFactor;
				         displayedHeight *= scaleFactor;
				       }
				       // Then center it within the bgRect
				       var x = r.x + (r.width - displayedWidth) / 2;
				       var y = r.y + (r.height - displayedHeight) / 2;
				     } else {
				       // Fallback if no valid background
					var x = canvas.width / 2 - displayedWidth / 2;
					var y = 20;
				     }

				// 4) Create the layer, storing full-res in `image`
				const newAssetLayer = {
					type: "asset",
					image: img, // keep the full image
					x,
					y,
					width: displayedWidth, // only initially 150
					height: displayedHeight,
					rotation: 0,
					isDragging: false,
					isResizing: false,
					isRotating: false,
					isSelected: true,
					dragOffsetX: 0,
					dragOffsetY: 0,
					rotationStart: 0,
					startAngle: 0,
					aspectRatio: displayedWidth / displayedHeight,
					lockAspectRatio: true,
				};

				// 5) Push new layer, etc.
				layers.current.forEach((layer) => {
					layer.isSelected = false;
				});
				layers.current.push(newAssetLayer);
				setIsAssetAdded(true);
				drawCanvas();
				updateAnySelected();
			};
			img.src = ev.target.result;
		};
		reader.readAsDataURL(file);
		e.target.value = "";
	}

	// Asset selection
	function handleAssetSelection(assetSrc) {
		const assetImg = new Image();
		assetImg.crossOrigin = "anonymous";
		assetImg.onload = () => {
			const canvas = canvasRef.current;

			// 1) Get the ORIGINAL dimensions from the loaded Image
			const originalWidth = assetImg.width;
			const originalHeight = assetImg.height;

			// 2) Decide the initial "starting size" for convenience
			const displayedWidth = Math.min(originalWidth, 150);
			const displayedHeight = (displayedWidth / originalWidth) * originalHeight;

			   // --- NEW: If bgRect is valid, ensure we place & scale inside the bgRect ---
			   if (bgRect?.current && bgRect.current.width > 0 && bgRect.current.height > 0) {
			     const r = bgRect.current;
			     // Scale down if 150x... is still bigger than the bg
			     const scaleFactor = Math.min(
			       r.width / displayedWidth,
			       r.height / displayedHeight
			     );
			     if (scaleFactor < 1) {
			       displayedWidth *= scaleFactor;
			       displayedHeight *= scaleFactor;
			     }
			     // center within background
			     var x = r.x + (r.width - displayedWidth) / 2;
			     var y = r.y + (r.height - displayedHeight) / 2;
			   } else {
			     // Fallback if no background
			  var x = canvas.width / 2 - displayedWidth / 2;
			  var y = 20;
			   }

			// 4) Store the full-res `image` in the layer,
			//    but use a smaller initial .width/.height
			const newAssetLayer = {
				type: "asset",
				image: assetImg, // full-res image
				x: x,
				y: y,
				width: displayedWidth, // but only displayed at 150px
				height: displayedHeight,
				rotation: 0,
				isDragging: false,
				isResizing: false,
				isRotating: false,
				isSelected: true,
				dragOffsetX: 0,
				dragOffsetY: 0,
				rotationStart: 0,
				startAngle: 0,
				aspectRatio: displayedWidth / displayedHeight,
				lockAspectRatio: true,
			};

			// 5) Deselect all other layers, push this new one, then draw
			layers.current.forEach((layer) => (layer.isSelected = false));
			layers.current.push(newAssetLayer);
			setIsAssetAdded(true);

			drawCanvas();
			updateAnySelected();
		};

		// Finally, assign the .src to actually load
		assetImg.src = assetSrc + "?t=" + Date.now();
	}

	const containerHeight = isMobile ? "max-h-[200px] md:max-h-[180px]" : "max-h-[400px]";

	useEffect(() => {
		const stored = sessionStorage.getItem("assetsTabState");
		if (stored) {
			try {
				const parsed = JSON.parse(stored);
				setAssetsAreReady(!!parsed.assetsAreReady);
				setLoadingAssets(!!parsed.loadingAssets);
				setCategory(parsed.category || "Category");
			} catch {}
		}
	}, []);

	// If no background, force the category to 'Category'
	useEffect(() => {
		if (!hasBackground) {
			setCategory("Category");
		}
	}, [hasBackground, setCategory]);

	// ===============================
	// C) SAVE to localStorage on changes
	// ===============================
	useEffect(() => {
		sessionStorage.setItem(
			"assetsTabState",
			JSON.stringify({
				assetsAreReady,
				loadingAssets,
				category,
			})
		);
	}, [assetsAreReady, loadingAssets, category]);

	useEffect(() => {
		function updateMaxHeight() {
			const w = window.innerWidth;
			if (w <= 768) {
				// Mobile
				setMaxHeightClass("max-h-[200px] md:max-h-[180px]");
			} else if (w <= 1280) {
				// Smaller laptop
				setMaxHeightClass("max-h-[250px]");
			} else {
				// Larger desktop
				setMaxHeightClass("max-h-[400px]");
			}
		}

		updateMaxHeight(); // run once on mount
		window.addEventListener("resize", updateMaxHeight);
		return () => window.removeEventListener("resize", updateMaxHeight);
	}, []);

	// RENDER
	return (
		<div className="flex flex-col gap-4 text-left">
			{/* 1) Top row: Load Assets + Upload Asset */}
			<div className="flex items-center gap-2">
				{/* Load Assets button */}
				<button
					type="button"
					onClick={handleLoadAllAssets}
					disabled={!hasBackground || assetsAreReady || loadingAssets}
					className="
            inline-block text-sm md:text-base px-4 py-2
            rounded-md bg-monadAccent text-monadWhite
            disabled:cursor-not-allowed disabled:opacity-60
          "
				>
					{loadingAssets ? "Loading..." : assetsAreReady ? "Assets Loaded" : "Load Assets"}
				</button>

				{/* Upload Asset button */}
				<button
					type="button"
					onClick={() => {
						if (hasBackground) {
							document.getElementById("localAssetInput")?.click();
						}
					}}
					disabled={!hasBackground}
					className="
            inline-block text-sm md:text-base px-4 py-2
            rounded-md bg-monadAccent text-monadWhite
            disabled:cursor-not-allowed disabled:opacity-60
          "
				>
					Upload Asset
				</button>

				{/* Hidden file input */}
				<input
					type="file"
					id="localAssetInput"
					style={{ display: "none" }}
					accept="image/*"
					onChange={handleLocalAssetSelect}
					disabled={!hasBackground}
				/>
			</div>

			{/* 2) If loading, show spinner/message in its own row below the buttons */}
			{loadingAssets && (
				<div className="flex items-center gap-2">
					<Spinner />
					<span className="text-yellow-400 text-sm md:text-base">Loading assets...</span>
				</div>
			)}
			{assetsAreReady && (
				<div className="flex items-start gap-2">
					{/* Lock Aspect Ratio toggle */}
					<span className="ml-2 md:ml-1 text-monadWhite text-sm md:text-base">
						When Resizing Lock Aspect Ratio:
					</span>
					<label className="relative inline-flex items-center cursor-pointer mr-3">
						<input
							type="checkbox"
							className="sr-only peer"
							checked={lockAspectLocal}
							onChange={(e) => {
								const checked = e.target.checked;
								// Update local state for the UI
								setLockAspectLocal(checked);
								// Also update the layer’s ref field
								if (selectedAsset) {
									selectedAsset.lockAspectRatio = checked;
								}
								drawCanvas();
							}}
						/>
						<div
							className="
              w-8 h-4 md:w-11 md:h-6 bg-gray-200 peer-focus:outline-none
              rounded-full peer dark:bg-gray-700
              peer-checked:after:translate-x-full
              peer-checked:after:border-white
              after:content-[''] after:absolute after:top-[2px] after:left-[2px]
              after:bg-white after:border-gray-300 after:border
              after:rounded-full after:h-4 md:after:h-5 after:w-4 md:after:w-5 after:transition-all
              peer-checked:bg-monadAccent
              "
						></div>
					</label>
				</div>
			)}
			{/* 3) Category Dropdown (shown if assets are loaded) */}
			{assetsAreReady && (
				<div>
					<select
						value={category}
						onChange={(e) => setCategory(e.target.value)}
						disabled={!hasBackground}
						className="
              px-2 py-1 rounded bg-monadDark text-white
              border border-monadGray
            "
					>
						<option value="Category">Category</option>
						<option value="Monad">Monad</option>
						<option value="SappySeals">Sappy Seals</option>
						<option value="Omnia">Omnia</option>
						<option value="Sealuminati">Sealuminati</option>
						<option value="TheVans">The Vans</option>
						<option value="SpikyNads">Spiky Nads</option>
						<option value="Meowwnads">Meowwnads</option>
						<option value="SLMND">SLMND</option>
						<option value="Chog">Chog</option>
						<option value="Monadverse">Monadverse</option>
						<option value="BlockNads">BlockNads</option>
						<option value="Dusted">Dusted</option>
					</select>
				</div>
			)}

			{/* 4) Thumbnails Grid */}
			{assetsAreReady && category !== "Category" && (
				<div className={`w-full bg-monadGray rounded-lg p-3 overflow-y-auto ${containerHeight}`}>
					{/* Monad */}
					{category === "Monad" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.Monad.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Monad Asset ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    transition-transform duration-200 hover:scale-110
                  "
								/>
							))}
						</div>
					)}

					{/* SappySeals */}
					{category === "SappySeals" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.SappySeals.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Sappy Seal ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    transition-transform duration-200 hover:scale-110
                  "
								/>
							))}
						</div>
					)}

					{/* Omnia */}
					{category === "Omnia" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.Omnia.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Omnia ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    transition-transform duration-200 hover:scale-110
                  "
								/>
							))}
						</div>
					)}

					{/* Sealuminati */}
					{category === "Sealuminati" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.Sealuminati.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Sealuminati ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}

					{/* TheVans */}
					{category === "TheVans" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.TheVans.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`The Vans ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}

					{/* SpikyNads */}
					{category === "SpikyNads" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.SpikyNads.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Spiky Nads ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}

					{/* Meowwnads */}
					{category === "Meowwnads" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.Meowwnads.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Meowwnads ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}

					{/* SLMND */}
					{category === "SLMND" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.SLMND.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`SLMND ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}

					{/* Chog */}
					{category === "Chog" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.Chog.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Chog ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}

					{/* Monadverse */}
					{category === "Monadverse" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.Monadverse.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Monadverse ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}

					{/* BlockNads */}
					{category === "BlockNads" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.BlockNads.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`BlockNads ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}

					{/* Dusted */}
					{category === "Dusted" && (
						<div className="grid grid-cols-4 gap-4">
							{allAssetUrlsByCategory.Dusted.map((url, idx) => (
								<img
									key={idx}
									src={preloadedImages[url]?.src || url}
									alt={`Dusted ${idx}`}
									onClick={() => handleAssetSelection(url)}
									className="
                    cursor-pointer w-20 h-20 object-contain
                    hover:scale-110 transition-transform
                  "
								/>
							))}
						</div>
					)}
				</div>
			)}
		</div>
	);
}
